export const theme = {
  accent: '#0d7377',
  accentLight: '#5DCAA5',
  gold: '#E8A02A',
  bg: '#0A0F14',
  bg1: '#0F1923',
  bg2: '#162532',
  text: '#E8EAED',
  muted: '#9AA0A6',
  dim: '#5A6470',
  font: "'DM Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
};
